import React, { useState, useRef, useEffect } from 'react'
import clsx from 'clsx'
// Centralized lodash imports - much cleaner!
import {
  find,
  head,
  omitBy,
  includes,
  toLower,
  isString,
  get,
  set,
  every,
  isNil,
  ceil,
  slice,
  cloneDeep,
  pullAt,
  merge,
  filter,
  truncate} from '@/utils/lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import AddMarketplace from '@/housefolios-components/Marketplace/AddMarketplace'
import BonusProperties from '@/housefolios-components/Properties/BonusProperties'
import CreatePortfolio from '@/housefolios-components/Portfolio/CreatePortfolio'
import DeletePortfolio from '@/housefolios-components/Portfolio/DeletePortfolio'
import DuplicatePortfolio from '@/housefolios-components/Portfolio/DuplicatePortfolio'
import EditPortfolio from '@/housefolios-components/Portfolio/EditPortfolio'
import EditAssumptions from '@/housefolios-components/AssumptionsSettings/EditAssumptions'
import EditMarketplace from '@/housefolios-components/Marketplace/EditMarketplace'
import SharePortfolio from '@/housefolios-components/Portfolio/SharePortfolio'
import DeleteProperties from '@/housefolios-components/Properties/DeleteProperties'

import {Grid, AppBar, Button, ButtonGroup, ClickAwayListener, Collapse, CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Drawer,  Grow, IconButton, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Paper, Popper, Table, TableCell, TableSortLabel, TextField, Toolbar, Tooltip, Typography, ListItemButton, Box} from '@mui/material'

import { connect } from 'react-redux'

import { NavLink, useNavigate } from 'react-router'
import {
  setSidebarToggleMobile,
  setSidebarToggle} from '../../reducers/ThemeOptions'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

// Additional lodash imports
import { map, isUndefined, isEmpty } from '@/utils/lodash'

import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import FolderOpenTwoToneIcon from '@mui/icons-material/FolderOpenTwoTone'
import HelpTwoToneIcon from '@mui/icons-material/HelpTwoTone'
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone'
import SendIcon from '@mui/icons-material/Send'
import LaunchIcon from '@mui/icons-material/Launch'
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone'
import { useMutation, useQuery } from "@apollo/client/react";
import { GET_SIDEBAR_PORTFOLIOS } from '@/housefolios-components/Portfolio/queries'
import withSession from '@/housefolios-components/Session/withSession'
import { GET_TEAM } from '@/housefolios-components/Team/queries'
import { Share, Warehouse } from '@mui/icons-material'
import ShareMarketplace from '@/housefolios-components/Marketplace/ShareMarketplace'
import { GET_TRASH } from '@/housefolios-components/Properties/queries'
import { UPDATE_ORGANIZATION } from '@/housefolios-components/OrganizationSettings/mutations'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { enqueueSnackbar } from 'notistack'
import RemoveSharedPortfolio from '@/housefolios-components/Portfolio/RemoveSharedPortfolio'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import MenuIcon from '@mui/icons-material/Menu'
import {
  RESET_CALCS,
  UPDATE_USER_BY_EMAIL} from '@/housefolios-components/ReportsComponents/mutations'
import { GET_AFFILIATES } from '@/housefolios-components/CreateAccount/CreateAccountCard/queries'
import Pagination from '@mui/material/Pagination'
import Add from '@mui/icons-material/Add'
import { Chat } from '@mui/icons-material'
import {
  UPDATE_AFFILIATE,
  ADD_AFFILIATE} from '@/housefolios-components/PartnerPortal/mutations'
import {
  TextValidator,
  ValidatorForm} from '@/housefolios-components/shared/muiFormValidator'
import { unset } from '@/utils/lodash'
import FileUpload from '@/housefolios-components/PropertyContainer/PropertyDashboard/FileUpload'
import { DEFAULT_PREFERENCES } from '@/housefolios-components/OrganizationSettings/OrganizationPreferences'
import RemoveSharedMarketplace from '@/housefolios-components/Marketplace/RemoveSharedMarketplace'
import useSorting, {
  getSorting,
  stableSort} from '@/hooks/useSorting'
import useAffiliate from '@/hooks/useAffiliate'
import ContactDialog from '@/housefolios-components/Dialogs/ContactSupport'
import { useRefetchOnWindowFocus } from '@/hooks/useRefetchOnWindowFocus'
import { GET_REALEFLOW_LOGIN_TOKEN } from '@/housefolios-components/PropertySearch/queries'
// import TempChat from '@/housefolios-components/TempChat';
import PortfoliosSection from './PortfoliosSection'
import MarketplacesSection from './MarketplacesSection'
import TrashSection from './TrashSection'
import SettingsSection from './SettingsSection'
import SupportSection from './SupportSection'
import SidebarNavigation from './SidebarNavigation'
import DetailsSection from './DetailsSection'

const DEFAULT_AFFILIATE_VALUES = {
  defaultStrategy: 'Buy & Hold',
  createAccount: {
    memberTrial: 3},
  launchpad: {
    memberLayout: true}}

const SidebarMenu = (props) => {
  const { setOpenFeedbackTour } = props
  const { activeOrg } = props.session.me
  const navigate = useNavigate()
  // All hooks must be called before any return
  const [selectedPortfolio, setSelectedPortfolio] = useState(null)
  const [anchorElMenu2, setAnchorElMenu2] = useState(null)
  const [canDelete, setCanDelete] = useState(false)
  const [anchorElMenu1, setAnchorElMenu1] = useState(null)
  const [openHousefoliosAdmin, setOpenHousefoliosAdmin] =
    useState(false)
  const [adminTab, setAdminTab] = useState('General')
  const [page, setPage] = useState(1)
  const [open, setOpen] = useState(true)
  const [adminEmail, setAdminEmail] = useState('')
  const [anchorElAffiliateMenu, setAnchorElAffiliateMenu] =
    useState(null)
  const [affiliateInput, setAffiliateInput] = useState(
    cloneDeep(DEFAULT_AFFILIATE_VALUES),
  )
  const [openAffiliateEdit, setOpenAffiliateEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [anchorElTrashMenu, setAnchorElTrashMenu] = useState(null)
  const [anchorElMenu3, setAnchorElMenu3] = useState(null)
  const [selectedMarketplace, setSelectedMarketplace] = useState(null)
  const [activePortfolioId, setActivePortfolioId] = useState(() => {
    const value = localStorage.getItem('portfolio')
    return !value || value === 'null' ? null : value
  })
  const [activeMarketplaceId, setActiveMarketplaceId] = useState(() => {
    const value = localStorage.getItem('marketplace')
    return !value || value === 'null' ? null : value
  })
  const [portfoliosDropdownOpen, setPortfoliosDropdownOpen] =
    useState(false)
  const [marketplacesDropdownOpen, setMarketplacesDropdownOpen] =
    useState(false)
  const [settingsDropdownOpen, setSettingsDropdownOpen] =
    useState(false)
  const [supportDropdownOpen, setSupportDropdownOpen] =
    useState(false)
  const [partnerDropdownOpen, setPartnerDropdownOpen] =
    useState(false)
  const [affiliateDropdownOpen, setAffiliateDropdownOpen] =
    useState(false)
  const [submittedDropdownOpen, setSubmittedDropdownOpen] =
    useState(false)
  const [openShare, setOpenShare] = useState(false)
  const [openMarkets, setOpenMarkets] = useState(false)
  const [selectedAffiliate, setSelectedAffiliate] = useState(
    head(activeOrg.affiliate),
  )
  const anchorRef = useRef(null)
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false)
  const [orderBy, setOrderBy] = useState('name')
  const [order, setOrder] = useState('asc')
  // All useQuery hooks
  const {
    loading: portfolioLoading,
    error: portfolioError,
    data: portfolioData,
    refetch: refetchSidebarPortfolios} = useQuery(GET_SIDEBAR_PORTFOLIOS)
  useRefetchOnWindowFocus(refetchSidebarPortfolios)
  const previousOrgIdRef = useRef(activeOrg?._id)
  useEffect(() => {
    const nextOrgId = activeOrg?._id
    if (previousOrgIdRef.current === nextOrgId) return
    previousOrgIdRef.current = nextOrgId
    refetchSidebarPortfolios()
  }, [activeOrg?._id, refetchSidebarPortfolios])
  const {
    loading: trashLoading,
    error: trashError,
    data: trashData} = useQuery(GET_TRASH)
  const {
    loading: teamLoading,
    error: teamError,
    data: teamData} = useQuery(GET_TEAM)
  const {
    loading: affiliateLoading,
    error: affiliateError,
    data: affiliateData} = useQuery(GET_AFFILIATES)
  const [propertySearchOptions, setPropertySearchOptions] = useState([
    ['pacemorby', 'astroflip'].includes(
      props?.session?.me?.activeOrg?.member,
    )
      ? 'Residential'
      : 'Leads',
  ])
  const memberNorm = String(
    props?.session?.me?.activeOrg?.member || '',
  ).toLowerCase()
  const isSpecialMember = ['pep', 'pacemorby', 'astroflip'].includes(
    memberNorm,
  )
  const isPropertySearchRetired = [
    'pep',
    'pacemorby',
    'astroflip',
  ].includes(memberNorm)
  const { data: realeflowData } = useQuery(
    GET_REALEFLOW_LOGIN_TOKEN,
    { skip: !isSpecialMember || isPropertySearchRetired },
  )
  const [{ urlAffiliate }] = useAffiliate({})

  useEffect(() => {
    if (realeflowData?.getRealeflowLoginToken) {
      const accountDetails =
        realeflowData.getRealeflowLoginToken.AccountDetails || {}
      const isDealSauce = ['pacemorby', 'astroflip'].includes(
        props?.session?.me?.activeOrg?.member,
      )

      const options = [isDealSauce ? 'Residential' : 'Leads']
      if (accountDetails.HasCommercialLeads) {
        options.push('Commercial')
      }
      if (accountDetails.HasResidentialInvestorLeads) {
        options.push('Find Investors')
      }
      if (isDealSauce) {
        options.push('Creative MLS')
      }
      setPropertySearchOptions(options)
    }
  }, [realeflowData])

  // Only after all hooks, do early returns
  if (
    portfolioLoading ||
    trashLoading ||
    teamLoading ||
    affiliateLoading
  )
    return <LoadingSkeleton variant="sidebar" />
  if (portfolioError) return `Error! ${portfolioError.message}`
  if (trashError) return `Error! ${trashError.message}`
  if (teamError) return `Error! ${teamError.message}`
  if (affiliateError) return `Error! ${affiliateError.message}`

  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 })

  function openPortfolioOptions(event, portfolio, canDelete) {
    setAnchorElMenu2(event.currentTarget)
    setSelectedPortfolio(portfolio)
    setCanDelete(canDelete)
    event.preventDefault()
    event.stopPropagation()
  }

  function handleClosePortfolioOptions() {
    setAnchorElMenu1(null)
    setAnchorElMenu2(null)
    //setSelectedPortfolio(null);
  }

  function handleOpenHousefoliosAdmin() {
    navigate('/housefolios-admin')
  }

  function handleCloseHousefoliosAdmin() {
    setOpenHousefoliosAdmin(false)
    setAdminTab('General')
    setPage(1)
  }

  const listItems = [
    {
      name: 'General',
      icon: <SettingsTwoToneIcon />},
    {
      name: 'Affiliate',
      icon: (
        <FontAwesomeIcon
          icon={['fas', 'gear']}
          sx={{ fontSize: 24 }}
        />
      )},
  ]

  function handleDrawerOpen() {
    setOpen(true)
  }
  function handleDrawerClose() {
    setOpen(false)
  }

  function handleOpenAffiliateOptions(event, affiliate) {
    setAnchorElAffiliateMenu(event.currentTarget)
    setAffiliateInput(affiliate)
    event.preventDefault()
    event.stopPropagation()
  }

  function handleCloseAffiliateOptions() {
    setAnchorElAffiliateMenu(null)
    setAffiliateInput(cloneDeep(DEFAULT_AFFILIATE_VALUES))
  }

  function handleOpenAffiliateEdit(event, affiliate = {}) {
    setOpenAffiliateEdit(true)
    // setAffiliateInput(affiliate);
    event.preventDefault()
    event.stopPropagation()
  }

  function handleCloseAffiliateEdit() {
    setOpenAffiliateEdit(false)
    setAffiliateInput(cloneDeep(DEFAULT_AFFILIATE_VALUES))
  }

  function onChangeAffiliate(event) {
    const { name = '', value = '', type = '' } = event.target
    let newValue = value
    if (type === 'number') newValue = Number(value)
    let newAffiliateInput = cloneDeep(affiliateInput)
    set(newAffiliateInput, name, newValue)
    setAffiliateInput(newAffiliateInput)
  }

  const uploadFile = (target) => (files) => {
    let newAffiliateInput = cloneDeep(affiliateInput)
    let newFiles = []
    map(files, (file) => {
      newFiles.push(file)
    })
    set(newAffiliateInput, target, newFiles)
    setAffiliateInput(newAffiliateInput)
  }

  const deleteFile = (target) => (index) => {
    let newAffiliateInput = cloneDeep(affiliateInput)
    let newFiles = get(newAffiliateInput, target) || []
    pullAt(newFiles, index)
    set(newAffiliateInput, target, newFiles)
    setAffiliateInput(newAffiliateInput)
  }

  const renderInput = (field) =>
    field.type === 'select' ? (
      <Grid size={{xs: 12, sm: 6}}>
        <TextValidator
          name={field.name}
          value={get(affiliateInput, field.name)}
          onChange={onChangeAffiliate}
          label={field.label}
          variant="outlined"
          fullWidth
          margin="dense"
          type={field.type}
          select
          validators={field.validators}
          errorMessages={field.errorMessages}
        >
          {map(field.options, (option) => (
            <MenuItem key={option.value} value={option.value}>
              <Grid container sx={{
                alignItems: "center"
              }}>
                <Grid>{option.label}</Grid>
              </Grid>
            </MenuItem>
          ))}
        </TextValidator>
      </Grid>
    ) : field.type === 'file' ? (
      <>
        <Grid size={{xs: 12, sm: 6}}>
          <Typography variant="subtitle1">{field.label}</Typography>
        </Grid>
        <Grid size={{xs: 12, sm: 6}}>
          <FileUpload
            documentId={affiliateInput._id}
            files={get(affiliateInput, field.name) || []}
            uploadFile={uploadFile(field.name)}
            deleteFile={deleteFile(field.name)}
            filetypes={['image/*']}
            button
            buttonStyle={{ marginTop: 0, marginBottom: 0 }}
            //writeOnly={true}
            notMulti={true}
            collection="affiliateImages"
          />
        </Grid>
      </>
    ) : (
      <Grid size={{xs: 12, sm: 6}}>
        <TextValidator
          name={field.name}
          value={get(affiliateInput, field.name)}
          onChange={onChangeAffiliate}
          label={field.label}
          variant="outlined"
          fullWidth
          margin="dense"
          helperText={field.helperText}
          type={field.type}
          validators={field.validators}
          errorMessages={field.errorMessages}
        />
      </Grid>
    )

  function openTrashOptions(event) {
    setAnchorElTrashMenu(event.currentTarget)
    event.preventDefault()
    event.stopPropagation()
  }

  function handleCloseTrashOptions() {
    setAnchorElTrashMenu(null)
  }

  function openMarketplaceOptions(event, marketplace) {
    setAnchorElMenu3(event.currentTarget)
    setSelectedMarketplace(marketplace)
    event.preventDefault()
    event.stopPropagation()
  }

  function handleCloseMarketplaceOptions() {
    setAnchorElMenu1(null)
    setAnchorElMenu2(null)
    setAnchorElMenu3(null)
  }

  const { setSidebarToggleMobile } = props

  const toggleSidebarMobile = () => setSidebarToggleMobile(false)

  const handlePortfolio = (portfolio) => {
    localStorage.setItem('portfolio', portfolio)
    setActivePortfolioId(!portfolio || portfolio === 'null' ? null : portfolio)
    toggleSidebarMobile()
  }

  const handleMarketplace = (marketplace) => {
    localStorage.setItem('marketplace', marketplace)
    setActiveMarketplaceId(
      !marketplace || marketplace === 'null' ? null : marketplace,
    )
    toggleSidebarMobile()
  }

  const togglePortfoliosDropdown = (event) => {
    setPortfoliosDropdownOpen(!portfoliosDropdownOpen)
    event.preventDefault()
    event.stopPropagation()
  }

  const toggleMarketplacesDropdown = (event) => {
    setMarketplacesDropdownOpen(!marketplacesDropdownOpen)
    event.preventDefault()
    event.stopPropagation()
  }

  const toggleSettingsDropdown = (event) => {
    setSettingsDropdownOpen(!settingsDropdownOpen)
    event.preventDefault()
    event.stopPropagation()
  }

  const toggleSupportDropdown = (event) => {
    setSupportDropdownOpen(!supportDropdownOpen)
    event.preventDefault()
    event.stopPropagation()
  }

  const togglePartnerDropdown = (event) => {
    event.preventDefault()
    setPartnerDropdownOpen(!partnerDropdownOpen)
    setAffiliateDropdownOpen(false)
  }

  const toggleAffiliateDropdown = (event) => {
    event?.preventDefault && event.preventDefault()
    setAffiliateDropdownOpen((open) => !open)
  }

  const toggleSubmittedDropdown = (event) => {
    setSubmittedDropdownOpen(!submittedDropdownOpen)
    event.preventDefault()
    event.stopPropagation()
  }

  const toggleAdminDropdown = (event) => {
    event.preventDefault()
    setAdminDropdownOpen((open) => !open)
  }

  var today = new Date()
  var resetDate = !isEmpty(props.session.me.activeOrg.subscriptions)
    ? props.session.me.activeOrg.subscriptions[0].current_period_end
      ? new Date(
          props.session.me.activeOrg.subscriptions[0]
            .current_period_end * 1000,
        )
      : null
    : props.session.me.activeOrg.parentCorp &&
        !isEmpty(props.session.me.activeOrg.parentCorp.subscriptions)
      ? props.session.me.activeOrg.parentCorp.subscriptions[0]
          .current_period_end
        ? new Date(
            props.session.me.activeOrg.parentCorp.subscriptions[0]
              .current_period_end * 1000,
          )
        : null
      : !isEmpty(
            props?.session?.me?.activeOrg
              ?.memberProvidedSubscriptions,
          )
        ? props?.session?.me?.activeOrg
            ?.memberProvidedSubscriptions[0].current_period_end
          ? new Date(
              props?.session?.me?.activeOrg
                ?.memberProvidedSubscriptions[0].current_period_end *
                1000,
            )
          : null
        : null
  if (!resetDate) {
    var month = today.getMonth()
    resetDate = new Date()
    if (month === 11) {
      resetDate.setFullYear(resetDate.getFullYear() + 1, 0, 1)
    } else resetDate.setMonth(month + 1, 1)
  }
  if (
    (resetDate.getFullYear() > today.getFullYear() &&
      today.getMonth() !== 11) ||
    resetDate.getMonth() > today.getMonth() + 1 ||
    resetDate.getMonth() === today.getMonth() + 1 ||
    resetDate.getDate() > today.getDate()
  ) {
    if (resetDate.getDate() > today.getDate()) {
      resetDate.setFullYear(today.getFullYear(), today.getMonth())
      if (resetDate.getMonth() !== today.getMonth())
        resetDate.setDate(0)
    } else {
      resetDate.setFullYear(today.getFullYear(), today.getMonth() + 1)
      if (
        resetDate.getMonth() !== today.getMonth() + 1 &&
        resetDate.getMonth() !== 0
      )
        resetDate.setDate(0)
    }
  }
  const timeToReset =
    (resetDate?.getTime?.() || 0) - (today?.getTime?.() || 0)
  const daysToReset = Math.floor(timeToReset / 1000 / 60 / 60 / 24)

  const LIMIT = props.session.me.limits.propertyLimit
  const role = find(
    props.session.me.roles,
    (role) =>
      role.organization._id === props.session.me.activeOrg._id,
  )

  const toggleShare = () => {
    setOpenShare(!openShare)
  }

  const toggleMarkets = () => {
    setOpenMarkets(!openMarkets)
  }

  const handleMarketsClose = (event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return
    }
    setOpenMarkets(false)
  }

  const { portfolios } = portfolioData

  const { trashedProperties } = trashData

  const teamCount = teamData.teamMembers.length
  const { limits } = props.session.me
  const { marketplaceLimit, teamLimit, portfolioLimit } = limits

  const { affiliates } = affiliateData

  const count = ceil(affiliates.length / 20)

  const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1}

  const tableHeaders = [
    { title: 'Name', name: 'name' },
    { title: 'Affiliate ID', name: 'hfpid' },
    { title: 'Company Name', name: 'companyName' },
    { title: 'Affiliate Tag', name: 'memberValue' },
    { title: 'Date Created', name: 'createdAt' },
    { title: 'Status', name: 'active' },
    { title: 'Actions', name: '' },
  ]

  const affiliateSections = [
    {
      label: 'Affiliate Info',
      fields: [
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          validators: ['required'],
          errorMessages: ['This field is required']},
        {
          name: 'hfpid',
          label: 'Affiliate ID',
          type: 'text',
          validators: ['required'],
          errorMessages: ['This field is required']},
        {
          name: 'companyName',
          label: 'Company Name',
          type: 'text',
          validators: ['required'],
          errorMessages: ['This field is required']},
        {
          name: 'email',
          label: 'Email',
          type: 'text',
          validators: ['required'],
          errorMessages: ['This field is required']},
        {
          name: 'phone',
          label: 'Phone',
          type: 'text',
          validators: ['matchRegexp:^[0-9()-]+$'],
          errorMessages: ['Not a valid phone number']},
        {
          name: 'commission',
          label: 'Commission %',
          type: 'number'},
        {
          name: 'memberValue',
          label: 'Affiliate Tag',
          type: 'text',
          validators: ['required'],
          errorMessages: ['This field is required']},
        {
          name: 'orgId',
          label: 'Org Id',
          type: 'text',
          validators: ['required'],
          errorMessages: ['This field is required']},
        {
          name: 'defaultStrategy',
          label: 'Default Strategy',
          type: 'select',
          options: map(
            merge(
              cloneDeep(DEFAULT_PREFERENCES),
              props.session.me.activeOrg.memberPreferences,
              props?.session?.me?.activeOrg?.preferences,
            ).general['strategies'],
            (preference) => ({
              value: preference.value,
              label: preference.value,
            }),
          ),
          validators: ['required'],
          errorMessages: ['This field is required']},
      ]},
    {
      label: 'Create Account',
      fields: [
        {
          name: 'createAccount.headerImage',
          label: 'Create Account Image',
          type: 'file'},
        {
          name: 'createAccount.memberTrial',
          label: 'Trial Days',
          type: 'number'},
      ]},
    {
      label: 'Sign In Page',
      fields: [
        {
          name: 'signIn.headerImage',
          label: 'Sign In Image',
          type: 'file'},
      ]},
    {
      label: 'Launchpad Page',
      fields: [
        {
          name: 'launchpad.memberLayout',
          label: 'Default Layout',
          type: 'select',
          options: [
            {
              value: true,
              label: 'Yes'},
            {
              value: false,
              label: 'No'},
          ]},
        {
          name: 'launchpad.memberWelcomeVideo',
          label: 'Welcome Video URL',
          type: 'text'},
      ]},
    {
      label: 'Left Nav',
      fields: [
        {
          name: 'sidebar.sidebarMemberFullImage',
          label: 'Upload Full Image',
          type: 'file'},
        {
          name: 'sidebar.sidebarMemberSmallImage',
          label: 'Upload Small Image',
          type: 'file'},
      ]},
    {
      label: 'Plan Details',
      fields: [
        {
          name: 'planDetails.price',
          label: 'Price',
          type: 'number',
          // validators: ['required'],
          errorMessages: ['This field is required'],
          helperText: `This value is equivelent to ${currencyFormat.format(
            get(affiliateInput, 'planDetails.price') / 100 || 0,
          )}`},
        {
          name: 'planDetails.paymentInterval',
          label: 'Payment Interval',
          type: 'select',
          options: [
            {
              value: 'monthly',
              label: 'Monthly'},
            {
              value: 'yearly',
              label: 'Yearly'},
          ],
          // validators: ['required'],
          errorMessages: ['This field is required']},
        {
          name: 'planDetails.portfolioLimit',
          label: 'Portfolio Limit',
          type: 'number'},
        {
          name: 'planDetails.marketplaceLimit',
          label: 'Marketplace Limit',
          type: 'number'},
        {
          name: 'planDetails.teamLimit',
          label: 'Team Limit',
          type: 'number'},
        {
          name: 'planDetails.propertyCount',
          label: 'Property Count',
          type: 'number'},
      ]},
  ]

  let newMarkets = omitBy(
    props.session.me.activeOrg.affiliateMarketplace || {},
    (value) =>
      value === (selectedMarketplace ? selectedMarketplace.url : ''),
  )
  newMarkets[selectedAffiliate || ''] = selectedMarketplace
    ? selectedMarketplace.url
    : ''

  // const togglePropertySearchDropdown = (event) => {
  //   setPropertySearchDropdownOpen(!propertySearchDropdownOpen)
  //   event.preventDefault()
  //   event.stopPropagation()
  // }

  const handleClickOpen = () => setOpenDialog(true)
  const handleClose = () => setOpenDialog(false)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleChange = (event, value) => {
    setPage(value)
  }

  function getSortDirection(order) {
    return order === 'asc' || order === 'desc' ? order : 'asc'
  }

  return (
    <>
      <Box sx={{
        position: "relative",
        height: "100%",
        maxHeight: "100%",
        overflowX: "hidden",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}>
        <SidebarNavigation
          clsx={clsx}
          propertySearchOptions={propertySearchOptions}
          toggleSidebarMobile={toggleSidebarMobile}
          handlePortfolio={handlePortfolio}
          handleMarketplace={handleMarketplace}
          activePortfolioId={activePortfolioId}
          activeMarketplaceId={activeMarketplaceId}
          portfolios={portfolios}
          portfoliosDropdownOpen={portfoliosDropdownOpen}
          togglePortfoliosDropdown={togglePortfoliosDropdown}
          openPortfolioOptions={openPortfolioOptions}
          selectedPortfolio={selectedPortfolio}
          canDelete={canDelete}
          anchorElMenu1={anchorElMenu1}
          anchorElMenu2={anchorElMenu2}
          handleClosePortfolioOptions={handleClosePortfolioOptions}
          member={props?.session?.me?.activeOrg?.member}
          trashedProperties={trashedProperties}
          anchorElTrashMenu={anchorElTrashMenu}
          openTrashOptions={openTrashOptions}
          handleCloseTrashOptions={handleCloseTrashOptions}
          marketplaces={props.session.me.activeOrg.marketPlaces}
          sharedMarketplaces={
            props.session.me.activeOrg.sharedMarketplaces
          }
          orgId={props.session.me.activeOrg._id}
          marketplacesDropdownOpen={marketplacesDropdownOpen}
          toggleMarketplacesDropdown={toggleMarketplacesDropdown}
          openMarketplaceOptions={openMarketplaceOptions}
          selectedMarketplace={selectedMarketplace}
          anchorElMenu3={anchorElMenu3}
          handleCloseMarketplaceOptions={
            handleCloseMarketplaceOptions
          }
          urlAffiliate={urlAffiliate}
          settingsDropdownOpen={settingsDropdownOpen}
          toggleSettingsDropdown={toggleSettingsDropdown}
          supportDropdownOpen={supportDropdownOpen}
          toggleSupportDropdown={toggleSupportDropdown}
          setOpenFeedbackTour={setOpenFeedbackTour}
          openDialog={openDialog}
          handleClose={handleClose}
          handleClickOpen={handleClickOpen}
          session={props.session}
          adminDropdownOpen={adminDropdownOpen}
          toggleAdminDropdown={toggleAdminDropdown}
          handleOpenHousefoliosAdmin={handleOpenHousefoliosAdmin}
          affiliateDropdownOpen={affiliateDropdownOpen}
          toggleAffiliateDropdown={toggleAffiliateDropdown}
          submittedDropdownOpen={submittedDropdownOpen}
          toggleSubmittedDropdown={toggleSubmittedDropdown}
          sidebarToggle={props.sidebarToggle}
        />
        {props.session.me &&
          !props.session.me.activeOrg.isRealeflow && (
            <DetailsSection
              session={props.session}
              LIMIT={LIMIT}
              marketplaceLimit={marketplaceLimit}
              teamLimit={teamLimit}
              portfolioLimit={portfolioLimit}
              resetDate={resetDate}
              daysToReset={daysToReset}
              teamCount={teamCount}
              portfolios={portfolios}
            />
          )}
      </Box>
    </>
  )
}

const mapStateToProps = (state) => ({
  sidebarUserbox: state.DeprecatedThemeOptions.sidebarUserbox,
  sidebarToggle: state.DeprecatedThemeOptions.sidebarToggle,
  sidebarToggleMobile:
    state.DeprecatedThemeOptions.sidebarToggleMobile,
})

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggle: (enable) => dispatch(setSidebarToggle(enable)),
  setSidebarToggleMobile: (enable) =>
    dispatch(setSidebarToggleMobile(enable))})

export default withSession(
  connect(mapStateToProps, mapDispatchToProps)(SidebarMenu),
)
